import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { WarningAmber as WarningIcon } from '@mui/icons-material';
import { hideDeleteRequestModal } from '../../redux/auth/authSlice';

export const DeleteRequestModal = () => {
  const dispatch = useDispatch();
  const { isOpen, message } = useSelector(state => state.auth.deleteRequestModal);

  const handleClose = () => {
    dispatch(hideDeleteRequestModal());
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1,
        color: '#FF9800',
        backgroundColor: '#FFF3E0',
        borderBottom: '1px solid #FFE0B2'
      }}>
        <WarningIcon />
        Account Delete Request
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {message || 'Your account has a pending delete request.'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please contact support if you need assistance with your account.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: '#FF9800',
            '&:hover': {
              backgroundColor: '#F57C00'
            },
            minWidth: '100px'
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};